import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import ServiceDetailHero from '../components/ServiceDetailHero';
import ServiceDetailContent from '../components/ServiceDetailContent';
import ServiceDetailFeatures from '../components/ServiceDetailFeatures';
import ServiceDetailProcess from '../components/ServiceDetailProcess';
import ServiceDetailPricing from '../components/ServiceDetailPricing';
import CTASection from '../../home/components/CTASection';
import { useSEO } from '../../../utils/seo';

const SocialMediaPage = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  useSEO({
    title: 'Sosyal Medya Yönetimi - Sigorta360 | Instagram, Facebook, LinkedIn Yönetimi',
    description: 'Sigorta acenteleri için profesyonel sosyal medya yönetimi hizmeti. Instagram, Facebook ve LinkedIn\'de içerik stratejisi, topluluk yönetimi ve performans analizi. 8.000₺\'den başlayan paketler.',
    keywords: 'sigorta sosyal medya, sigorta instagram yönetimi, sigorta facebook, sosyal medya paketi, sigorta içerik yönetimi',
    canonical: `${siteUrl}/hizmetler/sosyal-medya`,
    schema: {
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: 'Sosyal Medya Yönetimi',
      description: 'Sigorta sektörüne özel sosyal medya yönetimi ve içerik stratejisi hizmeti',
      provider: {
        '@type': 'Organization',
        name: 'Sigorta360',
        url: siteUrl
      },
      areaServed: {
        '@type': 'Country',
        name: 'Türkiye'
      },
      offers: {
        '@type': 'AggregateOffer',
        priceCurrency: 'TRY',
        lowPrice: '8000',
        highPrice: '18000',
        offerCount: '3'
      }
    }
  });

  const heroData = {
    category: 'Sosyal Medya',
    title: 'Sosyal Medya Yönetimi',
    description: 'Sigorta sektörüne özel içerik stratejisi ve topluluk yönetimi ile markanızı güçlendiriyoruz. Instagram, Facebook, LinkedIn ve Twitter\'da profesyonel varlığınızı oluşturun.',
    image: 'https://public.readdy.ai/ai/img_res/b9e5cb2e285c826c795dc8726401f5fa.jpg',
  };

  const contentData = {
    overview: 'Sosyal medya, sigorta acenteleri için güven inşa etmenin ve potansiyel müşterilere ulaşmanın en etkili yollarından biridir. Sigorta360 olarak, sigorta sektörüne özel içerik stratejileri geliştiriyor, hedef kitlenizle anlamlı etkileşimler kuruyoruz.',
    benefits: [
      {
        icon: 'ri-user-add-line',
        title: 'Marka Bilinirliği',
        description: 'Düzenli ve kaliteli paylaşımlarla markanızın görünürlüğünü artırın, potansiyel müşterilere ulaşın.',
      },
      {
        icon: 'ri-heart-line',
        title: 'Müşteri Etkileşimi',
        description: 'Yorumlar, mesajlar ve paylaşımlarla müşterilerinizle güçlü bağlar kurun, güven oluşturun.',
      },
      {
        icon: 'ri-line-chart-line',
        title: 'Lead Üretimi',
        description: 'Hedeflenmiş içerikler ve kampanyalarla nitelikli lead\'ler elde edin, satışlarınızı artırın.',
      },
      {
        icon: 'ri-shield-check-line',
        title: 'Güvenilirlik',
        description: 'Profesyonel içerikler ve düzenli paylaşımlarla sektörde güvenilir bir marka imajı oluşturun.',
      },
    ],
  };

  const featuresData = {
    title: 'Sosyal Medya Hizmetlerimiz',
    features: [
      {
        icon: 'ri-calendar-line',
        title: 'İçerik Planlaması',
        description: 'Aylık içerik takvimi oluşturma, sigorta sektörüne özel konu başlıkları belirleme, özel günler ve kampanyalar için planlama.',
      },
      {
        icon: 'ri-image-edit-line',
        title: 'Görsel Tasarım',
        description: 'Profesyonel görseller, infografikler, carousel tasarımları, marka kimliğine uygun şablonlar.',
      },
      {
        icon: 'ri-edit-line',
        title: 'Metin Yazarlığı',
        description: 'SEO uyumlu açıklamalar, etkili başlıklar, hashtag stratejisi, sigorta diline hakim içerikler.',
      },
      {
        icon: 'ri-time-line',
        title: 'Paylaşım Yönetimi',
        description: 'Otomatik zamanlama, en uygun saatlerde paylaşım, tüm platformlarda koordineli yayın.',
      },
      {
        icon: 'ri-message-3-line',
        title: 'Topluluk Yönetimi',
        description: 'Yorum ve mesajlara hızlı yanıt, müşteri sorularını yanıtlama, şikayet yönetimi.',
      },
      {
        icon: 'ri-bar-chart-line',
        title: 'Analiz & Raporlama',
        description: 'Haftalık performans raporları, etkileşim analizi, rakip analizi, strateji önerileri.',
      },
    ],
  };

  const processData = {
    title: 'Çalışma Sürecimiz',
    steps: [
      {
        number: '01',
        title: 'Keşif & Analiz',
        description: 'Marka analizi, hedef kitle belirleme, rakip analizi, mevcut sosyal medya durumu değerlendirmesi.',
      },
      {
        number: '02',
        title: 'Strateji Geliştirme',
        description: 'İçerik stratejisi oluşturma, platform seçimi, KPI belirleme, aylık hedefler koyma.',
      },
      {
        number: '03',
        title: 'İçerik Üretimi',
        description: 'Görsel tasarım, metin yazarlığı, video içerik üretimi, içerik takvimi hazırlama.',
      },
      {
        number: '04',
        title: 'Yayınlama & Yönetim',
        description: 'Düzenli paylaşımlar, topluluk yönetimi, etkileşim takibi, anlık müdahale.',
      },
      {
        number: '05',
        title: 'Analiz & Optimizasyon',
        description: 'Performans analizi, strateji optimizasyonu, A/B testleri, sürekli iyileştirme.',
      },
    ],
  };

  const pricingData = {
    title: 'Sosyal Medya Paketleri',
    packages: [
      {
        name: 'Başlangıç',
        price: '8.000',
        period: 'ay',
        description: 'Marka için temel sosyal medya varlığı',
        features: [
          '8 Post + 4 Story',
          'Temel içerik stratejisi',
          'Post ve story tasarımları',
          'Açıklama metinleri ve hashtag stratejisi',
          'Temel etkileşim yönetimi',
          'Aylık performans raporu',
        ],
        highlighted: false,
      },
      {
        name: 'Profesyonel',
        price: '12.000',
        period: 'ay',
        description: 'Düzenli etkileşim artırma ve analiz',
        features: [
          '12 Post + 8 Story',
          'Hedef kitle analizi ve strateji',
          'Profesyonel görsel tasarımlar',
          'DM ve yorum moderasyonu',
          'Etkileşim artırma çalışmaları',
          'Haftalık performans raporu',
          'Hashtag ve trend takibi',
        ],
        highlighted: true,
      },
      {
        name: 'Premium',
        price: '18.000',
        period: 'ay',
        description: 'Trend odaklı büyüme ve kampanya yönetimi',
        features: [
          '16 Post + 12 Story',
          'Gelişmiş topluluk yönetimi',
          'Kampanya içerikleri ve tasarımları',
          'Trend odaklı içerik üretimi',
          'Kriz yönetimi desteği',
          'Etkili topluluk etkileşimi',
          'Detaylı analiz ve strateji raporları',
          'Influencer işbirliği koordinasyonu',
        ],
        highlighted: false,
      },
    ],
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <ServiceDetailHero data={heroData} />
        <ServiceDetailContent data={contentData} />
        <ServiceDetailFeatures data={featuresData} />
        <ServiceDetailProcess data={processData} />
        <ServiceDetailPricing data={pricingData} />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default SocialMediaPage;
